import React from "react";

import { Dialog } from 'primereact/dialog';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Badge } from 'primereact/badge';
import { ProgressSpinner } from 'primereact/progressspinner';

import UserContext from '../context/UserContext';


class NewTestDialog extends React.Component {

	

	static contextType = UserContext;

	state = {
		isLoading: false,
		status: 0,
		comment:'',
	};


	componentDidMount() {
		
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.visible !== this.props.visible && this.props.visible === false) {
			this.setState({ status: 0 });
			this.setState({ comment: '' });
			this.setState({ isLoading: false });
		}
	}

	statusSelectedTemplate = (option) => {
		if (option) {
			return (
				<div className="flex align-items-center">
					<Badge value=" " style={{ backgroundColor: option.color }}></Badge>&nbsp;
					<div>{option.name}</div>
				</div>
			);
		}
	};

	cancelDialog() {
		if (this.props.onClose != null) {		
			this.props.onClose();
		}
	}

	closeDialog() {
		if (this.props.onClose != null) {
			this.setState({ isLoading: true });
			this.props.onClose({ status: this.state.status, comment: this.state.comment });
		}
	}

	onChange(field, value) {
		this.setState({ [field]: value });
		this.setState({ modified: true });
	}

	render() {

		const TestStatus = [
			{ id: 0, name: " ", color: '#FFFFFF' },
			{ id: 1, name: "Passed", color: '#62D96B' },
			{ id: 2, name: "Warning", color: '#FFC940' },
			{ id: 3, name: "Failed", color: '#DB3737' },
		];
		const footerContent = (
			<div>
				<Button label="Cancel" icon="pi pi-times" onClick={() => this.cancelDialog()} className="p-button-secondary" disabled={this.state.comment.isLoading} />
				<Button label="Sign test" icon="pi pi-check" onClick={() => this.closeDialog()} disabled={this.state.comment.length === 0 || this.state.status === 0 || this.state.isLoading} />
			</div>
		);

		return (
			<Dialog header={<div>New test {this.state.isLoading?<ProgressSpinner style={{ width: '1rem', height: '1rem' }} />:null}</div>} visible={this.props.visible} style={{ width: '25rem', height: '25rem', overflow: 'hidden' }}  footer={footerContent}
				modal contentStyle={{ height: '300px' }} closable={false} >
				<ConfirmDialog />

				<div style={{ flexWrap: 'wrap', display: 'flex', width: '100%', flexDirection: 'row', flexBasis: 'auto' }}>

					<div className="p-fluid md:w-22rem">

						<div className="p-field">
							<label className="p-field-label">Test status</label>
							<Dropdown
								value={this.state.status}
								onChange={(e) => { this.onChange('status', e.target.value); }}
								options={TestStatus}
								optionValue = "id"
								optionLabel = "name"
								placeholder = "&nbsp;"
								className = "w-full md:w-22rem"
								valueTemplate = {this.statusSelectedTemplate.bind(this)}
								itemTemplate = {this.statusSelectedTemplate.bind(this)}
							/>
						</div>

						<div className="p-field">
							<label className="p-field-label">Comment</label>
							<InputTextarea className="w-full md:w-22rem" value={this.state.comment} onChange={(e) => { this.onChange('comment', e.target.value); }} rows={4}  />
						</div>

					</div>
				</div>
			</Dialog>
		);
	}
}
export default (NewTestDialog);
